import Commons from '../../../../Services/Common/Common';

export const M_TBG_CUSTOM_05_Schema = {
  mapper: {
    search1: {
      DepCd: (context) => Commons.EncryptAES(context.userInfo?.depCd ?? ''),
    },
  },
};
